'use strict';

import * as pluralize_ from 'pluralize';

const pluralize = pluralize_;

export function JSONAPI (res?: string) {
	return (target: any) => {
		const original = target;

		function construct (constructor, args) {
			const c: any = function () {
				return constructor.apply(this, args);
			};
			c.prototype = constructor.prototype;
			return new c();
		}

		if ( !res ) {
			res = pluralize(original.name.toLowerCase());
		}

		const f: any = function (...args) {
			if ( args && Array.isArray(args) && args.length > 0 ) {
				args = [ Object.assign(args[ 0 ], { resource: res }), args.splice(0, 1) ];
			} else {
				args = [ { resource: res } ];
			}
			return construct(original, args);
		};

		f.prototype = original.prototype;
		f.prototype.resource = res;

		return f;
	};
}
